export default function createLinearProgressPalette(theme, current, _base) {
    return {
        linearProgress: {
            indeterminate: {
                before: {
                    backgroundColor: current[500],
                },
                after: {
                    backgroundColor: current[200],
                },
            },
            progress: {
                backgroundColor: current[500],
            },
            rail: {
                backgroundColor: current[100],
            },
        },
    };
}
//# sourceMappingURL=linear-progress.js.map